<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="叫料单号">
              <global-select
                :value.sync="queryParams.callDocNumber"
                selectType="selectSearch"
                requestApi="/inv/invCallRequestLines/callDocNumberBox"
                searchParam="callDocNumber"
                :setParams="{ type: 2 }"
                :selectItem="{ value: 'realValue', label: 'label' }" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemCode"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="发货组织">
              <global-select
                :value.sync="queryParams.supplyOrganizationCodeList"
                selectType="selectAssembleMultiple"
                :selectData="inventOrg"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :assembleLabel="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="需求组织">
              <global-select
                :value.sync="queryParams.organizationCodeList"
                selectType="selectAssembleMultiple"
                :selectData="inventOrg"
                :default-active-first-option="true"
                @init-success-call-back="handleOrganizationInitSuccess"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :assembleLabel="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.status"
                selectType="select"
                :selectData="statusList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="要求到货时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.staDemandDateList) }}</template>
                <a-range-picker
                  v-model="queryParams.staDemandDateList"
                  show-time
                  format="YYYY/MM/DD HH:mm:ss"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiInvCallRequestLinesNewExport" ref="download" />
      <a-button @click="handleSave" :loading="saveLoading" type="primary" :disabled="selectedRows.length === 0" v-hasPermi="['inv:invCallRequestLines:warehousing']">保存</a-button>
      <a-button @click="handleExport">导出</a-button>
    </div>
    <template v-slot:table>
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :selectedRows.sync="selectedRows"
        :multi-select="true"
        rowKey="id"
        :scroll="{ fixScreen: true, x: 2800 }"
        @selectedRowChange="selectedRowChange"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ASSEMBLY_RECEIVING_GOODS_LIST, // 表格方案配置唯一值
              }"
      >
        <span slot="receivedQuantityTitle">
          <i class="toRequired">*</i>收货数量
        </span>
        <span slot="subinventoryTitle">
          <i class="toRequired">*</i>收货子库
        </span>
        <span slot="goodsAllocationTitle">
          <i class="toRequired">*</i>收货货位
        </span>
        <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
          <div :key="item.dataIndex">
            <span v-if="item.type === 'select'">
              <global-select
                :value.sync="record[item.dataIndex]"
                :selectType="item.selectType ? item.selectType : 'select'"
                :focusGet="item.focusGet ? item.focusGet : false"
                :requestApi="item.requestApi"
                :selectData="setArray(item.dataList)"
                :selectItem="{ value: item.value, label: item.label }"
                :searchParam="item.searchParam ? item.searchParam : ''"
                :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                :allowClear="false"
                size="small"
                :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              />
            </span>
            <span v-else-if="item.type === 'input'">
              <a-input v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'inputNumber'">
              <a-input-number v-model="record[item.dataIndex]" :min="0" size="small" />
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </template>
      </ls-api-table>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiInvCallRequestLinesWarehousingList, apiInvCallRequestLinesWarehousing, apiInvCallRequestLinesNewExport } from '@/api/mes/partsHandover/assemblyReceivingGoods'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'AssemblyReceivingGoods',
  components: { DownloadModal },
  data () {
    return {
      apiInvCallRequestLinesNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvCallRequestLinesWarehousingList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        callDocNumber: undefined,
        itemCode: undefined,
        supplyOrganizationCodeList: undefined,
        organizationCodeList: undefined,
        status: undefined,
        staDemandDateList: undefined,
        staDemandDate: undefined,
        endDemandDate: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格字段
      columns: [
        {
          title: '叫料单号',
          stickyFixed: 'left',
          dataIndex: 'callDocNumber',
          align: 'center',
          width: 150
        },
        {
          title: '行号',
          dataIndex: 'lineNumber',
          align: 'center',
          width: 100
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true,
          width: 260
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true,
          width: 500
        },
        {
          title: '单位',
          dataIndex: 'uom',
          align: 'center',
          width: 100
        },
        {
          title: '需求组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 250
        },
        {
          title: '要求到货时间',
          dataIndex: 'demandDate',
          align: 'center',
          type: "text",
          width: 250
        },
        {
          title: '要货数量',
          dataIndex: 'demandQty',
          align: 'center',
          width: 120
        },
        {
          title: '待收货数量',
          dataIndex: 'quantityToReceived',
          align: 'center',
          width: 120
        },
        {
          title: '已收货数量',
          dataIndex: 'receivedQuantity',
          align: 'center',
          width: 120
        },
        // {
        //   // title: '收货数量',
        //   dataIndex: 'receivedQuantityNew',
        //   scopedSlots: { customRender: 'receivedQuantityNew', title: "receivedQuantityTitle" },
        //   align: 'center',
        //   type: 'inputNumber',
        //   width: 120
        // },
        // {
        //   // title: '收货子库',
        //   dataIndex: 'subinventory',
        //   scopedSlots: { customRender: 'subinventory', title: "subinventoryTitle" },
        //   align: 'center',
        //   width: 180,
        //   type: "select",
        //   selectType: "selectSearch",
        //   focusGet: true,
        //   searchParam: "warehouseCode",
        //   setParams: true,
        //   requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
        //   value: 'realValue',
        //   label: 'label'
        // },
        // {
        //   // title: '收货货位',
        //   dataIndex: 'goodsAllocation',
        //   scopedSlots: { customRender: 'goodsAllocation', title: "goodsAllocationTitle" },
        //   align: 'center',
        //   width: 180,
        //   type: "select",
        //   selectType: "selectSearch",
        //   focusGet: true,
        //   searchParam: "locationCode",
        //   setParams: true,
        //   requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
        //   value: 'realValue',
        //   label: 'label'
        // },
        {
          title: '组装中心工单号',
          dataIndex: 'deWipEntityName',
          align: 'center',
          width: 200
        },
        {
          title: '零部件工单号',
          dataIndex: 'suWipEntityName',
          align: 'center',
          width: 200
        },
        {
          title: '发货组织',
          dataIndex: 'supplyOrganizationName',
          align: 'center',
          width: 200
        },
        {
          title: '发货批次',
          dataIndex: 'lotNumber',
          align: 'center',
          width: 200
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center',
          width: 180
        },
        {
          title: '最后更新人',
          dataIndex: 'updateName',
          align: 'center',
          width: 150
        },
        {
          title: '最后更新时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' },
          type: "text",
          width: 180
        }
      ],
      statusList: [], // 状态
      saveLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  watch: {
    "queryParams.staDemandDateList" (newVal, oldVal) {
      this.queryParams.staDemandDate = newVal[0] && this.$moment(newVal[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryParams.endDemandDate = newVal[1] && this.$moment(newVal[1]).format('YYYY-MM-DD HH:mm:ss')
      this.$refs.dataTable.searchParams = this.queryParams;
    }
  },
  created () {
    this.getLookupList('INV_CALL_DOC_STATUS', 'statusList')
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    handleOrganizationInitSuccess () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 保存
    handleSave () {
      const flag = false
      const arr = JSON.parse(JSON.stringify(this.selectedRows))
      for (let i = 0; i < arr.length; i++) {
        arr[i].receivedQuantity = arr[i].receivedQuantityNew
        // if (!arr[i].subinventory || !arr[i].goodsAllocation) {
        //   this.$message.warning('必填项不能为空！')
        //   flag = true
        //   return
        // }
        // if (!arr[i].receivedQuantity || Number(arr[i].receivedQuantity) <= 0) {
        //   this.$message.warning('收货数量 不能为空且需大于0')
        //   flag = true
        //   return
        // }
        // if (Number(arr[i].receivedQuantity) > Number(arr[i].quantityToReceived)) {
        //   this.$message.warning('收货数量 不能超过待收货数量')
        //   flag = true
        //   return
        // }
      }
      if (flag) {
        return false
      }
      this.saveLoading = true
      apiInvCallRequestLinesWarehousing(arr).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.saveLoading = false
      }).catch(e => {
        this.saveLoading = false
      })
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        callDocNumber: undefined,
        itemCode: undefined,
        supplyOrganizationCodeList: undefined,
        organizationCodeList: undefined,
        status: undefined,
        staDemandDateList: undefined,
        staDemandDate: undefined,
        endDemandDate: undefined
      }
      this.onSearch()
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "subinventory") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "goodsAllocation") {
        return { subinventoryCode: record.subinventory }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "INV_CALL_DOC_STATUS") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute2 === "Y") {
              arr2.push(element)
            }
          });
          this[arr] = arr2
          return
        }
        this[arr] = response.rows
      })
    },
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('inv/invCallRequestLines/warehousingListExport', {
      //   ...this.queryParams
      // }, `组装中心收货_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
/deep/.ant-select{
  width: 100%
}
/deep/.ant-drawer-content-wrapper{
  .ant-form-item{
    .ant-form-item-control-wrapper{
      width: 83.33% !important
    }
  }
}
</style>
